import React from 'react';
import './CSS/PrivacyPolicyPopup.css';

const PrivacyPolicyPopup = ({ onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Política de Privacidad</h2>
        <p>
          Esta web utiliza cookies para que podamos ofrecerte la mejor experiencia de usuario posible.
          La información de las cookies se almacena en tu navegador y realiza funciones tales como reconocerte cuando vuelves a nuestra web o ayudarnos a comprender qué secciones de la web encuentras más interesantes y útiles.
          Nunca almacenamos información personal.
          Tienes toda la información sobre privacidad, derechos legales y cookies en nuestra página de política de privacidad y política de cookies.
        </p>
        <button onClick={onClose} className="close-popup-btn">
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default PrivacyPolicyPopup;